<template>
  <el-radio-group :value="value" @change.native="onChange">
    <el-radio
      v-for="item in options"
      :label="item.value"
      :key="item.value"
    >{{item.displayName}}</el-radio>
  </el-radio-group>
</template>

<script>
export default {
  props: ['props', 'value', 'isSizeGroup'],
  data() {
    return {
      isHasOptionsComp: true,
    }
  },
  computed: {
    options() {
      return this.props.dataSource.options;
    },
    key() {
      return this.props.name
    },
    defaultValue() {
      return this.props.dataSource.defaultValue;
    },
  },
  methods: {
    onChange(v) {
      this.$emit('change', v.target.value)
    }
  },
  updated() {
    
  }
};
</script>